import { useEffect, useState } from "react";
import AllLayout from "./all-layout";
import StoreListing from "./store-listing";
import StoreProfile from "./store-profile";
import { useProduct } from "../contexts";
import { useScrollClassToggle } from "./browse-category/useScrollClassToggle";

interface SellerPageProps {
  user?: Record<string, unknown>;
  currentList?: Record<string, unknown>[];
  [key: string]: unknown;
}

const SellerPage = (props: SellerPageProps) => {
  const { replaceCurrentList } = useProduct();
  const [hasInitialized, setHasInitialized] = useState(false);

  const { currentList, user } = props;

  // Initialize with props data if available (for SSR/SSG)
  useEffect(() => {
    if (currentList && currentList.length > 0 && !hasInitialized) {
      if (replaceCurrentList) {
        replaceCurrentList(currentList as unknown as Parameters<typeof replaceCurrentList>[0]);
      }
      // eslint-disable-next-line react-hooks/set-state-in-effect -- one-time initialization guard: seeds the product context from SSR/SSG props and flips the flag so it never re-runs; sequencing must stay in the effect
      setHasInitialized(true);
    }
  }, [currentList, hasInitialized, replaceCurrentList]);

  // Marks the body once the reader is a screen down, as on every grid page.
  useScrollClassToggle('scrolling');

  return (
    <AllLayout header={true} search={true} nav={true} showAd={true}>
      <article className="page seller-page same-color">
        <StoreProfile {...props} />
        <StoreListing id={user?.id as string | number} />
      </article>
    </AllLayout>
  );
};

export default SellerPage;
